__turbopack_context__.v({
  "blueButton": "CartEmptyState-module__gqyUxa__blueButton",
  "centered": "CartEmptyState-module__gqyUxa__centered",
  "emptyTitle": "CartEmptyState-module__gqyUxa__emptyTitle",
  "root": "CartEmptyState-module__gqyUxa__root",
});
